module.exports = __webpack_public_path__ + "img/profile-2user@2x(1).b8d1058c.png";